import { useRef } from 'react';
import { Modal } from '../../Universal/NovusDSImports';
import { useClickOutside } from '../../Hooks/useClickOutside';

const SnapshotModal = (props) => {
  const { selectedCamera, markerOpenRef, closeModal } = props;
  const MarkerExcludedRef = useRef(null);

  useClickOutside(
    markerOpenRef,
    () => {
      closeModal();
    },
    [MarkerExcludedRef]
  );

  return (
    <div className="h-100" ref={markerOpenRef}>
      <img
        data-testid="snapshot"
        src={selectedCamera.snapshotAddress}
        alt={selectedCamera.locationName}
        width="100%"
        height="100%"
      />
    </div>
  );
};

export default Modal(SnapshotModal);
